import React from 'react';
import { SceneState, useSceneStore } from '../../state/sceneStore';
import { formatHeightCutoff, parseHeightCutoffInput } from '../../utils/pointCloudHeightFilter';

const panelStyle: React.CSSProperties = {
  background: 'rgba(25, 35, 45, 0.8)',
  color: 'white',
  padding: '15px',
  borderRadius: '8px',
  border: '1px solid #334155',
  marginBottom: '10px',
};

const inputStyle: React.CSSProperties = {
  width: '72px',
  background: '#334155',
  color: 'white',
  border: '1px solid #475569',
  borderRadius: '4px',
  padding: '4px 6px',
  fontSize: '12px',
};

const AlignmentHeightFilterPanel: React.FC = () => {
  const sensors = useSceneStore((state: SceneState) => state.sensors);
  const alignmentHeightMin = useSceneStore((state: SceneState) => state.alignmentHeightMin);
  const alignmentHeightMax = useSceneStore((state: SceneState) => state.alignmentHeightMax);
  const setAlignmentHeightMin = useSceneStore((state: SceneState) => state.setAlignmentHeightMin);
  const setAlignmentHeightMax = useSceneStore((state: SceneState) => state.setAlignmentHeightMax);

  const sensorsWithPcd = sensors.filter((sensor) => sensor.pcdUrl);
  if (sensorsWithPcd.length === 0) {
    return null;
  }

  return (
    <div style={panelStyle} data-testid="alignment-height-filter">
      <h4 style={{ marginTop: 0, marginBottom: '12px' }}>Height Filter</h4>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <label style={{ fontSize: '12px', color: '#cbd5e1', flex: 1, minWidth: '120px' }}>
          Hide below
          <input
            type="number"
            step="0.1"
            placeholder="off"
            value={formatHeightCutoff(alignmentHeightMin)}
            onChange={(event) => setAlignmentHeightMin(parseHeightCutoffInput(event.target.value))}
            style={{ ...inputStyle, width: '100%', marginTop: '4px' }}
            data-testid="alignment-height-min"
          />
        </label>
        <label style={{ fontSize: '12px', color: '#cbd5e1', flex: 1, minWidth: '120px' }}>
          Hide above
          <input
            type="number"
            step="0.1"
            placeholder="off"
            value={formatHeightCutoff(alignmentHeightMax)}
            onChange={(event) => setAlignmentHeightMax(parseHeightCutoffInput(event.target.value))}
            style={{ ...inputStyle, width: '100%', marginTop: '4px' }}
            data-testid="alignment-height-max"
          />
        </label>
      </div>
    </div>
  );
};

export default AlignmentHeightFilterPanel;
